import {Option, OptionValue, PropsValue, RecursiveSelect} from "./types";
import React, {useEffect, useMemo, useState} from "react";
import getDataForTree from "src/utils/helpers/getDataForTree";
import {NodeId} from "react-accessible-treeview";

const useRecursiveSelect = (
  {
    recursiveSelect,
    propsValue
  }:
  {
    recursiveSelect?: RecursiveSelect
    propsValue?: PropsValue
  }
) => {
  const [openedOptions, setOpenedOptions] = useState<OptionValue[]>([]);
  const toggleOpenedOptions = (id: number, event: React.MouseEvent) => {
    event.stopPropagation();
    setOpenedOptions(openedOptions.reduce((acc:OptionValue[], i) => {
      return i === id ? [...acc, id]: acc;
    }, []));
  };
  useEffect(() => {
    if (recursiveSelect && recursiveSelect.data && propsValue) {
      const preparedData = getDataForTree(recursiveSelect.data);
      const findedItem = preparedData.find((item) => item.id == propsValue);
      const findParents = (
        array: OptionValue[],
        parent: NodeId
      ): OptionValue[] => {
        const findedParent = preparedData.find((item) => item.id == parent);
        if (!findedParent) {
          return array;
        }
        return [
          ...array,
          findedParent.id,
          ...(findedParent?.parent ? findParents(array, findedParent.parent) : []),
        ];
      };

      if (findedItem?.parent) {
        setOpenedOptions(findParents([], findedItem.parent));
      }
    }
  }, [recursiveSelect, propsValue]);
  const recursiveOptions = useMemo(() => {
    if (recursiveSelect) {
      const res: Option[] = [];
      if (!recursiveSelect.data) return [];
      const preparedData = getDataForTree(recursiveSelect.data);
      const handleData = (item: any, level: number) => {
        if (level !== -1) {
          const data: any = {};

          if (recursiveSelect.idFieldName) {
            data[recursiveSelect.idFieldName[0]] =
              item.metadata[recursiveSelect.idFieldName[1]];
          }
          data.title = null;
          data.value = item.metadata.id;
          data.element = (
            <div className="align-center user-select-none">
              <div
                className="hidden-part"
                style={{ paddingLeft: `${15 * level}px` }}
              />
              {item.metadata[recursiveSelect.titleFieldName]}
              {item.children?.length ? (
                <span
                  onClick={(event) => {
                    toggleOpenedOptions(data.value, event);
                  }}
                  className="ml-3 hidden-part"
                >
                  ▼
                </span>
              ) : null}
            </div>
          );
          res.push(data);
        }

        if (openedOptions.includes(item.id) || level === -1) {
          item.children.forEach((children: any) => {
            handleData(
              preparedData.find((childrenItem) => childrenItem.id === children),
              level + 1
            );
          });
        }
      };
      handleData(preparedData[0], -1);
      return res
    }
    return null
  }, [recursiveSelect])
  return {
    openedOptions,
    toggleOpenedOptions,
    recursiveOptions
  }
}
export default useRecursiveSelect